import PocketBase from 'pocketbase';
import { Platform } from 'react-native';

export function getApiBase(): string {
  let base = process.env.EXPO_PUBLIC_API_BASE_URL || '';
  if (
    Platform.OS === 'web' &&
    (!base || /^https?:\/\/(localhost|127\.0\.0\.1)(:\\d+)?$/i.test(base)) &&
    typeof window !== 'undefined' &&
    window.location?.origin
  ) {
    base = window.location.origin;
  }
  return base;
}

const apiBase = getApiBase();
console.log('[pb] API base:', apiBase);

export const pb = new PocketBase(apiBase);
// Avoid inspecting response bodies here to prevent consuming the stream before SDK parsing.
// If you need request/response tracing later, clone the response safely.